import "./Styles/eventlog-card-status.scss";
import React, { useEffect, useState } from "react";
import moment from 'moment';

function EventlogCardStatus(props) {
  const [iconColor, setIconColor] = useState("#8E8C99");

  function formatTime(minutes) {
    if (minutes < 60) {
      return `${minutes}m`;
    } else if (minutes < 1440) { // 1440 minutos = 24 horas
      const horas = Math.floor(minutes / 60);
      return `${horas}h`;
    } else if (minutes < 10080) { // 10080 minutos = 7 dias
      const dias = Math.floor(minutes / 1440);
      return `${dias}d`;
    } else {
      const semanas = Math.floor(minutes / 10080);
      return `${semanas}w`;
    }
  }

  useEffect(() => {
    switch (props.eventToken) {
      case 'TOKEN_HISTORY_EVENT_STOPPED':
        setIconColor("#44CD45");
        break;
      case 'TOKEN_HISTORY_EVENT_STARTED':
        setIconColor("#6362E7");
        break;
    }
  }, [props.eventToken]);

  return (
    <div className="eventlog-card-status">
      <div className={`eventlog-status-icon`} style={{ backgroundColor: iconColor }} />
      <span className="status-name">{formatTime(moment().diff(moment.utc(props.dateUTC), 'minutes'))} ago</span>
    </div>
  );
}

export default EventlogCardStatus;
